import { render, staticRenderFns } from "./startPage.vue?vue&type=template&id=5a99a2ca&"
import script from "./startPage.vue?vue&type=script&lang=js&"
export * from "./startPage.vue?vue&type=script&lang=js&"
import style0 from "./startPage.vue?vue&type=style&index=0&id=5a99a2ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports